import { render } from "./MessageComposeSection.vue?vue&type=template&id=2867dabe&scoped=true"
import script from "./MessageComposeSection.vue?vue&type=script&lang=js"
export * from "./MessageComposeSection.vue?vue&type=script&lang=js"

import "./MessageComposeSection.vue?vue&type=style&index=0&id=2867dabe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2867dabe"]])

export default __exports__